function setHeaderHeightVar() {
    const header = document.querySelector('sticky-header');
    if (header) {
      const altura = header.offsetHeight;
      document.documentElement.style.setProperty('--cabrio-header-height', `${altura}px`);
    }
  }
  
  window.addEventListener('load', setHeaderHeightVar);
  window.addEventListener('resize', setHeaderHeightVar);
  

  document.addEventListener('DOMContentLoaded', function(){
    const swatchLinks = document.querySelectorAll('.swatch__link[data-hover-img][data-hover-srcset]');
    
    swatchLinks.forEach(function(link) {
      link.addEventListener('mouseenter', function(){
        const hoverImgUrl = link.getAttribute('data-hover-img');
        const hoverSrcset = link.getAttribute('data-hover-srcset');
        const card = link.closest('.card-wrapper');
        if(card){
          const hoverImg = card.querySelector('.card__media img:not(.product-first-media)');
          if(hoverImg){
            if(!hoverImg.getAttribute('data-default-src')){
              hoverImg.setAttribute('data-default-src', hoverImg.getAttribute('src'));
              hoverImg.setAttribute('data-default-srcset', hoverImg.getAttribute('srcset'));
            }
            hoverImg.setAttribute('src', hoverImgUrl);
            hoverImg.setAttribute('srcset', hoverSrcset);
          }
        }
      });
      
      link.addEventListener('mouseleave', function(){
        const card = link.closest('.card-wrapper');
        if(card){
          const hoverImg = card.querySelector('.card__media img:not(.product-first-media)');
          if(hoverImg && hoverImg.getAttribute('data-default-src')){
            hoverImg.setAttribute('src', hoverImg.getAttribute('data-default-src'));
            hoverImg.setAttribute('srcset', hoverImg.getAttribute('data-default-srcset'));
          }
        }
      });
    });
  });
  